// Bedroom count for a job.
//
// The DB column is jobs.bedroom_count. Older or modifier-priced jobs may
// have it empty while the count still lives in
// the Zenbooker intake (zenbooker_intake[].selected_options) or in the SF
// service modifiers (service_modifiers[].selectedOptions), so fall back to
// those before giving up.

const parseArray = (raw) => {
  if (Array.isArray(raw)) return raw
  if (typeof raw === 'string') {
    try {
      const parsed = JSON.parse(raw)
      return Array.isArray(parsed) ? parsed : []
    } catch {
      return []
    }
  }
  return []
}

const toCount = (label) => {
  if (label == null || label === '') return null
  const n = parseInt(String(label), 10)
  if (Number.isFinite(n)) return n
  if (/studio/i.test(String(label))) return 0
  return null
}

const fromIntake = (job) => {
  for (const field of parseArray(job?.zenbooker_intake)) {
    const name = String(field?.field_name || '').toLowerCase()
    if (!name.includes('bedroom')) continue
    const sel = Array.isArray(field.selected_options) ? field.selected_options[0] : null
    const count = toCount(sel?.text || sel?.display_label || field.text_value)
    if (count != null) return count
  }
  return null
}

export const bedroomsFromModifiers = (modifiers) => fromModifiers({ service_modifiers: modifiers })

const fromModifiers = (job) => {
  for (const m of parseArray(job?.service_modifiers)) {
    const name = String(m?.title || m?.name || m?.label || '').toLowerCase()
    if (!name.includes('bedroom')) continue
    const opts = Array.isArray(m.selectedOptions) ? m.selectedOptions : []
    if (m.selectionType === 'quantity') {
      const qty = opts.reduce((s, o) => s + (parseInt(o?.selectedQuantity, 10) || 0), 0)
      if (qty > 0) return qty
      continue
    }
    const opt = opts[0]
    const count = toCount(opt?.label || opt?.title || opt?.name || opt?.text)
    if (count != null) return count
  }
  return null
}

const stored = (value) => {
  if (value == null || value === '') return null
  const n = parseInt(value, 10)
  return Number.isFinite(n) ? n : null
}

export const getJobBedrooms = (job) =>
  stored(job?.bedroom_count) ?? stored(job?.bedrooms) ?? fromIntake(job) ?? fromModifiers(job)
